import TOKEN_GENERATOR from "./tokenGen";
import cookieOps from "./cookieOps";
import requestProvider from "./axiosHandler";

const loginService = (list) => {

    return requestProvider
        .post("/authenticate/login", {
            username: list.username,
            password: list.password
        })
        .then(r => {
            let token = TOKEN_GENERATOR(r.data.token)
            localStorage.setItem('name', r.data.user.name)
            localStorage.setItem('surname', r.data.user.surname)
            cookieOps.writeCookie({mySweetApple: token})
            window.location = '/landing'
        })
        .catch((e) => e)
}
export default loginService